import React from 'react';

import { EngagementsView } from '../components/EngagementsView/EngagementsView';
import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type TalentEngagementsPageProps = {
  name?: string;
};

export const TalentEngagementsPage = ({
  name = 'TALENT_ENGAGEMENTS_PAGE',
}: TalentEngagementsPageProps) => {
  useDocumentTitle('Engagements');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation
        pathToEngagements="."
        startTab="ENGAGEMENTS_TAB"
      />
      <EngagementsView />
    </div>
  );
};
